import { StyleService } from '@ui-kitten/components';

//Device Detect
//import Device from '../../libs/react-native-device-detection';
//import { Platform } from 'react-native';

const styles = StyleService.create({
  title: { marginBottom: 20, alignSelf: 'center', textAlign: 'center', color: 'color-primary-500' },
  view: {
    alignItems: 'center',
  },
});

export default styles;
